import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Row } from "./RowsTableUsers";
import { Box, TablePagination } from "@mui/material";
import ModalDetailsUser from "../ModalDetailsUser";
import UserModal from "../ModalUser";
import EditUserModal from "../ModalEditUser";
import ModalResetPassword from "../ModalRsetPassword";
import DeactivateAccountModal from "../ModalActiveAndDeactivateAccount";

export default function TableUsers({ rows = [], setLoading, type }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [showModalDetailsUser, setShowModalUser] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [showModalEditUser, setShowModalEditUser] = React.useState(false);
  const [showModalResetPassword, setShowModalResetPassword] =
    React.useState(false);

  const [showModalDeactivateAccount, setShowModalDeactivateAccount] = React.useState(false)
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = React.useMemo(() => {
    if (!rows || rows.length === 0) return [];

    return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [page, rowsPerPage, rows]);
  return (
    <>
        {selectedUser && (
        <DeactivateAccountModal
          open={showModalDeactivateAccount}
          userData={selectedUser}
          setOpen={setShowModalDeactivateAccount}
          setLoading={setLoading}
        />
      )}
      {selectedUser && (
        <ModalDetailsUser
          open={showModalDetailsUser}
          userData={selectedUser}
          setOpen={setShowModalUser}
          setLoading={setLoading}
        />
      )}
      {selectedUser && (
        <UserModal
          open={showModalEditUser}
          setLoading={setLoading}
          setOpen={setShowModalEditUser}
          userData={selectedUser}
        />
      )}
      {selectedUser && (
        <EditUserModal
          open={showModalEditUser}
          setOpen={setShowModalEditUser}
          setLoading={setLoading}
          userData={selectedUser}
        />
      )}
      {selectedUser && (
        <ModalResetPassword
          open={showModalResetPassword}
          setOpen={setShowModalResetPassword}
          setLoading={setLoading}
          userData={selectedUser}
        />
      )}
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  {/* <TableCell>ID</TableCell> */}
                  <TableCell align="center">Nombre</TableCell>
                  <TableCell align="center">Apellidos</TableCell>
                  <TableCell align="center">Correo</TableCell>
                  {/* <TableCell align="center">Teléfono</TableCell> */}
                  <TableCell align="center">Estado de la cuenta</TableCell>
                  <TableCell align="center">Membresía</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows.map((row) => {
                  return (
                    <Row
                      key={row._id}
                      row={row}
                      setSelectedUser={setSelectedUser}
                      setShowModalUser={setShowModalUser}
                      setShowModalEditUser={setShowModalEditUser}
                      setShowModalResetPassword={setShowModalResetPassword}
                      setShowModalDeactivateAccount={ setShowModalDeactivateAccount}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
}
